import React from 'react';
import { Component } from "react";
import {Navbar} from "react-bootstrap";
import { connect } from 'react-redux';
import {Nav} from "react-bootstrap";
import UserPanel from '../controls/UserPanel';

class DefaultLayout extends Component {
    render() { 
      if(this.props.token){
        return (
<>
      <Navbar bg="light" expand="lg">
        <Navbar.Brand href="/">IVy Consulting</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link href="/product/company/about">About</Nav.Link>
            <Nav.Link href="/product/company/contact">Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
        <UserPanel />
      </Navbar>
      {this.props.children}

</>
		);
        } else {
          return (
            <>
              <Navbar bg="light" expand="lg">
                <Navbar.Brand href="/">IVy Consulting</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="mr-auto">
                    <Nav.Link href="/product/company/about">About</Nav.Link>
                    <Nav.Link href="/product/company/contact">Contact</Nav.Link>
                  </Nav>
                </Navbar.Collapse>
                <UserPanel />
              </Navbar>
              {this.props.children}
            </>
          );
    }
    }
}
const mapStateToProps = (state) => {
  return {
      error: state.TokenReducer.error,
      pending: state.TokenReducer.pending,
      token: state.TokenReducer.result
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout); 
